module.exports = __webpack_public_path__ + "static/img/banner.3d47b96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner/banner.png
// module id = T6Rj
// module chunks = 1